import { render, staticRenderFns } from "./BaseHumburger.vue?vue&type=template&id=18aa4f1e&scoped=true&"
import script from "./BaseHumburger.vue?vue&type=script&lang=js&"
export * from "./BaseHumburger.vue?vue&type=script&lang=js&"
import style0 from "./BaseHumburger.vue?vue&type=style&index=0&id=18aa4f1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa4f1e",
  null
  
)

export default component.exports